var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pb-20 md:pb-28",attrs:{"id":_vm.id}},[_c(_vm.isDesktop ? 'CategoryFeaturesBlocks' : 'CategoryFeaturesBlocksMobile',{tag:"component",attrs:{"items":_vm.featuresItems}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }